var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-phone',{staticClass:"mt-3",attrs:{"new-user":false,"form-message":"Введите номер телефона и выберите пароль","form-show-cancel":_vm.isAndroid,"form-show-features":""},on:{"done":_vm.onDone,"cancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }